import { render, staticRenderFns } from "./DescrizioneScommessa.vue?vue&type=template&id=711537b1&"
import script from "./DescrizioneScommessa.vue?vue&type=script&lang=js&"
export * from "./DescrizioneScommessa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports